import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0 24C0 5.52 20-6.02 36 3.21A24 24 0 0 1 48 24c0 18.48-20 30.02-36 20.78A24 24 0 0 1 0 24Zm30.4-8.74v-3.92a23.7 23.7 0 0 0-2.96-.17c-4.72 0-6.43 2.23-6.43 6.4v2.5h-3.4v4.15h3.41v12.6h5.07V24.24h3.8l.44-4.15h-4.24V17.5c0-1.55.45-2.25 2.04-2.25Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }